import { render, staticRenderFns } from "./VisitorsPrices.vue?vue&type=template&id=18f04794&scoped=true"
import script from "./VisitorsPrices.vue?vue&type=script&lang=js"
export * from "./VisitorsPrices.vue?vue&type=script&lang=js"
import style0 from "./VisitorsPrices.vue?vue&type=style&index=0&id=18f04794&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f04794",
  null
  
)

export default component.exports